import React from 'react'

import TablePagination from '@mui/material/TablePagination'
import Container from './styles'

const Pagination = ({ ...rest }) => {
  return (
    <Container>
      <TablePagination {...rest} />
    </Container>
  )
}

export default Pagination
